module.exports = " <div> <div id=headerCommon></div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DHeader.vue
 ** module id = 607
 ** module chunks = 2
 **/